'use client'

import React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "lib/utils";

const Popover = ({ children, ...props }) => (
  <PopoverPrimitive.Root modal={false} {...props}>
    {children}
  </PopoverPrimitive.Root>
);

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef(
  ({ className, align = "center", sideOffset = 4, theme = "light", ...props }, ref) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-72 rounded-md p-4 shadow-md outline-none border transition-colors " +
            (theme === "dark"
              ? "bg-[#1e1e2e] border-[#2c2f3a] text-white"
              : "bg-white border-gray-200 text-gray-900"),
          "data-[state=open]:animate-in data-[state=closed]:animate-out " +
            "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 " +
            "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 " +
            "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 " +
            "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
);

PopoverContent.displayName =
  PopoverPrimitive.Content.displayName || "PopoverContent";

export { Popover, PopoverTrigger, PopoverContent };